<template>
    <div class="threedotsmenu-hover">
        <button v-if="$slots?.trigger" type="button" class="threedotsmenu-hover-button-slot" @click="showDropdown()">
            <slot name="trigger"></slot>
        </button>
        <button v-else type="button" class="threedotsmenu-hover-button" @click="showDropdown()">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-more-horizontal"><circle cx="12" cy="12" r="1"></circle><circle cx="19" cy="12" r="1"></circle><circle cx="5" cy="12" r="1"></circle></svg>
        </button>
        <div class="threedotsmenu-content" :style="$slots?.trigger ? 'margin-top: 32px' : ''">
            <slot></slot>
        </div>

    </div>
</template>

<style scoped>
* {
    margin: 0;
    padding: 0px
}

.showLeft {
    text-shadow: none !important;
    color: #fff !important;
}

.icons li {
    list-style: none outside none;
    margin-right: 15px;
    margin-top: 3px;
    vertical-align: top;
    border-radius: 50%;
    pointer-events: none;
}

.dropbtn {
    border: none;
    cursor: pointer;
}

.threedotsmenu {
    position: relative;
    bottom: 0;
    display: inline-block;
}

.threedotsmenu button {
    font-size: 1.4rem;
}

.threedotsmenu a:hover {
    background-color: #f1f1f1
}

.show {
    position: absolute;
    display: block;
    right: 0;
}
</style>

<style>
.threedotsmenu-content a, .threedotsmenu-content button {
    color: black;
    padding: 12px 16px;
    text-decoration: none;
    display: block;
    width: 100%;
    text-align: left;
}

/* change to hover */
.threedotsmenu-hover {
    position: relative;
    width: 32px
}

.threedotsmenu-hover-button {
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: transparent;
    border: none;
    opacity: 0.4;
    margin: 0px;
}

.threedotsmenu-hover-button-slot {
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: transparent;
    border: none;
    margin: 0px;
}

.threedotsmenu-hover:hover .threedotsmenu-content {
    display: block;
    position: absolute;
    right: 0;
    top: 0;
}

.threedotsmenu-hover .threedotsmenu-content {
    display: none;
    position: relative;
    background-color: #fff;
    min-width: 160px;
    overflow: auto;
    box-shadow: 0px 12px 15px -2px rgba(0, 0, 0, 0.15);
    z-index: 1;
    border-radius: 4px;
    border: 1px solid #eeeeee;
    padding: 8px;
}

.threedotsmenu-hover .threedotsmenu-content a, 
.threedotsmenu-hover .threedotsmenu-content button {
    color: black;
    padding: 12px;
    text-decoration: none;
    display: block;
    width: 100%;
    text-align: left;
    font-size: 13px !important;
    margin: 0px;
    border-radius: 4px;
}

.threedotsmenu-hover .threedotsmenu-content a:hover, 
.threedotsmenu-hover .threedotsmenu-content button:hover {
    transform: translate(0px);
    background-color: #f5f9ff;
}

</style>

<script>
export default {
    name: "three-dot-menu",
    data() {
        return {
            show: false,
        }
    },
    methods: {
        getClassDropdown() {
            return {
                "threedotsmenu-content": true,
                "show": this.show,
            };
        },
        showDropdown() {
            this.show = !this.show;
        }
    },
}
</script>